export enum SHADE_INFO_POSITION_TYPE {
    NONE = 'none',
    ABOVE = 'above',
    BELOW = 'below',
    INLINE = 'inline'
}
